import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 150px;
  width: auto;
  cursor: pointer;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 100%;
    flex-direction: column;
  }
`;

export const Separator = styled.div`
  width: 1px;
  height: 40px;
  background-color: white;
  margin: 10px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 100%;
    height: 3px;
    margin: 0;
  }
`;

export const DayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 135px;
  width: auto;
  padding-top: 10px;

  .date-mobile {
    display: none;
    border: 0;
    line-height: 15px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: calc(100vw - 100px);
    height: 85px;
    padding: 0;

    .date-mobile {
      display: block;
      line-height: 22px;
    }

    .date-desktop {
      display: none;
    }
  }
`;

export const MatchesContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ children }) =>
    children.length && `repeat(${children.length},58px)`};
  column-gap: 20px;
  height: 100px;
  width: 100%;
  padding: 0 20px 0 20px;
  justify-content: center;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    padding: 0 0 10px;
    grid-template-columns: ${({ children }) =>
      children.length > 1
        ? 'calc(50% - 10px) calc(50% - 10px)'
        : 'calc(50% - 10px)'};
    height: 72px;
  }
`;

export const MatchItem = styled.div`
  height: 100%;
  width: 58px;
  transition: background-color 0.2s;
  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 100%;
    margin: 0;
    display: flex;
    height: 50px;
  }
`;

export const MatchCompetitionLogo = styled.img`
  background-color: ${({ theme }) => theme.white};
  object-fit: contain;
  height: 50px;
  width: 58px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 50%;
  }
`;

export const MatchInfo = styled.div`
  width: 58px;
  height: 50px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme, competition }) =>
    competition === 1 ? theme.coral : theme.turquoise};
  background-color: ${({ theme, selected }) => selected && theme.purple};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    width: 50%;
  }
`;

export const MatchRound = styled.p`
  font-size: ${({ theme }) => theme.label}px;
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${({ theme }) => theme.white};
  line-height: 1.2;
`;

export const RoundNumber = styled.p`
  font-size: ${({ theme }) => theme.h4}px;
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${({ theme }) => theme.white};
  line-height: 1.2;
`;

export const Date = styled.p`
  box-sizing: content-box;
  grid-column-start: 1;
  grid-column-end: 3;
  margin: 0;
  bottom: 0;
  width: 100%;
  color: ${({ theme }) => theme.white};
  text-align: center;
  font-size: ${({ theme }) => theme.h5}px;
  line-height: ${({ theme }) => theme.label * 2 + 10}px;
  font-family: ${({ theme }) => theme.primaryFont};
  border-bottom: ${({ theme, selected }) =>
    selected ? `solid 4px ${theme.white}` : `solid 0px ${theme.dark}`};
  transition: color 0.2s, border-color 0.2s, border-width 0.2s;
`;
